import { Action } from 'redux';
import { spawn, actionChannel, take, call } from 'redux-saga/effects';

/**
 * Places all actions that matches pattern into a queue to run these actions sequentially.
 */
export function* takeOneByOne<A extends Action>(
    pattern: string,
    worker: (action: A) => any,
) {
    yield spawn(takeOneByOneWatch);

    function* takeOneByOneWatch() {
        const channel = yield actionChannel(pattern);

        while (true) {
            const payload = yield take(channel);
            yield call(worker, payload);
        }
    }
}